<template>
    <div class="container">

        <div class="topBg">
            <mt-swipe ref="swipe" :auto="0" @change="handleChange" :show-indicators="false" >
                <mt-swipe-item v-for="(item,index) in biaoList" :key="index">
                    <div class="swiper_bg">
                        <div class="swiper_top">
                            <div class="swiper_top_item1">
                                <span class="swiper_top_span1">仪表号</span>
                                <span class="swiper_top_span2">{{item.meterNo}}</span>
                            </div>
                            <div class="swiper_top_item2">
                                <span class="swiper_top_span1">仪表名</span>
                                <span class="swiper_top_span2">{{item.name}}</span>
                            </div>
                            <span class="swiper_top_span3">{{index+1}}/{{biaoList.length}}</span>
                        </div>
                        <div class="swiper_footer">
                            <span class="swiper_top_span4">{{item.merchantName}}</span>
                            <span class="swiper_top_span5">{{item.storeNo}}</span>
                        </div>

                    </div>
                </mt-swipe-item>
            </mt-swipe>
            <img @click="changeSwipeIndex(-1)"
                    class="prevIcon"
                    src='../../assets/images/btn_coupon_last@2x.png'/>
            <img @click="changeSwipeIndex(1)"
                    class="nextIcon"
                    src='../../assets/images/btn_coupon_next@2x.png'/>

        </div>
         <div class="listView"  v-if="dataList.length>0">
            <scroll :allLoaded="allLoaded"
                    :data="dataList"
                    @pulldown="loadData"
                    @loadUp="loadup" >
                    <div class="listItem" v-for="(item,index) in dataList" :key="index">
                        <div class="listItemTop">
                            <div class="listItemTop_line">
                                <span class="listItemTop_span" @click="showPickView()">{{item.group}}</span>
                                <img class="listItemTop_dot" @click="showPickView()" src="../../assets/images/icon_arrows_unfold@2x.png"/>
                            </div>
                            <div class="listItemTop_line1">
                                <span class="listItemTop_span1">月耗电量:</span>
                                <span class="listItemTop_span2">{{item.allkwh}}</span>
                                <span class="listItemTop_span3">度数</span>
                            </div>

                        </div>
                        <div class="list_bodyItem" v-for="(jitem,jindex) in item.list" :key="jindex">
                             <div class="list_bodyItem_line">
                                 <span class="list_bodyItem_span1">{{jitem.timeStr}}</span>
                                 <div class="list_bodyItem_div" >
                                    <span class="list_bodyItem_span2">{{jitem.eachUsage}}</span>
                                    <span class="list_bodyItem_span3">度</span>
                                 </div>
                             </div>

                        </div>
                    </div>
                     <!-- <span >{{dataListCount}}</span> -->
            </scroll>
         </div>
        <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
            <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
                <div class="picker_wrap">
                    <div class="picker_btn" @click="popupVisible=false">取消</div>
                    <div class="picker_btn2" @click="handleConfirm">确认</div>
                </div>
            </mt-picker>
        </mt-popup>
    </div>
</template>

<script>
import util from "../../utils/util";
import storage from '../../utils/storage';
import { mapState,mapActions } from "vuex";
import Scroll from "../../components/scroll";
import { callSpaceUp} from "../../utils/api";
export default {
  components: { Scroll },
  name: "hpRuseDetailed",
  data() {
    return {
        timeout:'',
        biaoList:[],

        year:'',
        yearList:[{
            flex: 1,
            values:["2021"] ,
            className: 'slot1',
            textAlign: 'center'
        }],
        pickList:[{
            flex: 1,
            values:["2021"] ,
            className: 'slot1',
            textAlign: 'center'
        }],
        popupVisible:false,

        allList:[],

        page:1,
        // yueList:[1,2,3,4,5,6,7,8,9,10],
        dataList:[],
        dataListCount:0,
        allLoaded:false,


       swipeIndex:0,
       selectIntelligence:'',
       intelligenceCode:'' , //表号
       storeNo:'', //单元号
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
      this.getDeviceList()
  },
  methods: {
        ...mapActions(['getMarketInfo','getUserInfo','getTenantInfo','getTenantInfoList','getTheme','getHolidayStyle']),
        loadData(){
            this.page = 1;
            this.queryMeterReadByDeviceId()

        },
        loadup(){
            if(!this.allLoaded){
                this.page =this.page+1;
                this.queryMeterReadByDeviceId()
            }
        },
        // 获取电表
        getDeviceList() {
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                subProjectIds:this.common.marketInfo.id,
                companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                page:1,
                pageSize:100,
                spaceName:'',
                platform: "RST",
                merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                url: "/property/rstRepair/queryDeviceMonitorPage"
            }
            callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                   var list =res.body.data.list
                    for(var i=0;i<list.length;i++){
                        var item =list[i];
                        var pitem  =item.prpDeviceSpaceRelBeans
                        if(pitem && pitem.length>0){
                            item.storeNo = pitem[0].subProjectName +'-'+pitem[0].buildName+"-"+pitem[0].spaceName
                        }
                    }
                    this.biaoList =list;
                    if(list.length>0){
                        this.intelligenceCode =list[0].id
                        this.storeNo = list[0].storeNo
                        this.selectIntelligence =this.biaoList[0]
                        //this.queryMeterReadByDeviceId()
                        this.queryMeterReadMonthCountByDeviceId()
                    }else{
                        util.showToast("没有相关电表数据")
                    }
                }
            });
        },

        //获取月用电量
        queryMeterReadMonthCountByDeviceId(){
            var params = {
                 marketId: this.common.marketInfo.id,
                 companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                 merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                 deviceId:this.intelligenceCode,
                 url:"/property/rstRepair/queryMeterReadMonthCountByDeviceId"
             }
             this.year=''
             callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                    // var obj =res.body.data
                    // this.syAmount = obj.balance ||0
                    this.allList = res.body.data;
                    var yearList =[];
                    for(var n=0;n<this.allList.length;n++){
                        var nitem=this.allList[n]
                        yearList.push(nitem.year+'-'+nitem.month)
                    }
                    this.yearList[0].values=yearList;
                    this.queryMeterReadByDeviceId()

                }
            });

        },
        //获取月用电明细
        queryMeterReadByDeviceId(){
            var params = {
                userId: this.common.userId,
                marketId: this.common.marketInfo.id,
                companyId:  this.common.marketInfo.cityId,   //space up 的 业主ID 20,//
                platform: "RST",
                merchantId:  this.common.userTenantInfo.companyId ? this.common.userTenantInfo.companyId : '', // space up 的 租客ID 44,//
                deviceId:this.intelligenceCode,
                page:this.page,
                pageSize:20,
                url: "/property/rstRepair/queryMeterReadByDeviceId"
            }
            console.log( "queryMeterReadByDeviceId"  + JSON.stringify(params))
            if(this.year){
                params.beginTime =this.year+"-01"
            }
            callSpaceUp(params).then(res => {
                if (res.res.code == 10000) {
                   console.log('1111')
                   var dlist =[];
                   if(this.page==1){
                      this.dataList =[]
                   }else{
                       dlist = this.dataList
                   }
                   var list = res.body.data.list;
                   console.log("list === " + JSON.stringify(list))
                   if(list.length<20){
                       this.allLoaded=true;
                   }

                //    var bList =[];
                   for(var i=0;i<list.length;i++){
                        var item =  list[i];
                        // var reg = new RegExp( '.' , "g" )
                        // var timeStr =   item.writeTime.replace(reg, '/')
                        // replace 全部无效  先写死2次replace
                        //var timeStr =item.writeTime.replace('.','/');
                        // timeStr =timeStr.replace('.','/');
                        var timeStr =item.writeTime
                        timeStr =timeStr.replace(/\./g, '/')
                        console.log("timeStr ==== " +  timeStr)
                        var date = new Date(timeStr);
                        console.log("date ==== " +  date)
                        const year = date.getFullYear()
                        const month = date.getMonth() + 1
                        const day = date.getDate()
                        item.group = year+"年"+month+"月";
                        item.timeStr =  month+"-"+day;
                        var hasItem =false;
                        for(var j=0;j< dlist.length;j++){
                            var rItem = dlist[j];
                            if(rItem.group == item.group){
                                hasItem =true;
                                // rItem.allkwh = rItem.allkwh+item.eachUsage
                                rItem.list.push(item)
                                this.dataListCount =this.dataListCount+1
                                break;
                            }
                        }
                        console.log("hasItem  === " +hasItem)
                        if(hasItem ==false){
                            var allkwh =0;
                            for(var  k=0; k<this.allList.length ; k++){
                                    var kItem = this.allList[k];
                                    var syear = kItem.year;
                                    var smonth = kItem.month;
                                    console.log(year  +'  ' + syear + '' + month + ' ' +smonth)
                                    if(year ==  parseInt(syear) &&   month == parseInt(smonth)){
                                        allkwh =kItem.monthUsage;
                                        break;
                                    }

                            }

                            var newItem = {
                                group:item.group,
                                allkwh:allkwh,
                                list:[]
                            }
                            newItem.list.push(item);
                            dlist.push(newItem);
                            this.dataListCount =this.dataListCount+1
                        }


                   }
                  //this.dataList =dlist;
                   this.$set(this,'dataList',dlist)
                   console.log("dataList === " + JSON.stringify(this.dataList))

                }
            });

        },


        handleChange(index){
            this.swipeIndex =index
            clearTimeout(this.timeout) //防止连续滚动触发
            this.timeout = setTimeout(() => {
                 this.swipeIndex =index
                 console.log("handleChangeIndex ===  "  + index)
                 this.intelligenceCode =this.biaoList[index].id
                 this.storeNo = this.biaoList[index].storeNo
                 this.selectIntelligence =this.biaoList[index]
                 this.page=1;
                 this.queryMeterReadMonthCountByDeviceId();
            }, 500)
        },
        changeSwipeIndex(index){
            // console.log("changeSwipeIndex ===  "  + this.$refs.swipe.index)
            // var swipeIndex = this.$refs.swipe.index; //轮播当前索引
            if (index==1) {
                //if(this.swipeIndex<this.biaoList.length){
                    this.$refs.swipe.next(); // 转到下一张轮播图
                //}
                // this.swipeIndex=this.$refs.swipe.index
            } else if (index==-1) {
               // if(this.swipeIndex>0){
                    this.$refs.swipe.prev(); // 转到前一张轮播图
                //}
                //  this.swipeIndex=this.$refs.swipe.index
            }
            console.log("hpRecharge    === " +  this.swipeIndex)
        },

        showPickView(){
            console.log("in showPickView")
            this.popupVisible=true;
            this.pickList = this. yearList;
        },
        onValuesChange (picker, values) {
            if (values[0] > values[1]) {
                picker.setSlotValue(1, values[0]);
            }
        },

        handleConfirm(){
            this.popupVisible = false
            var valve =  this.$refs.picker.getValues()[0];
            this.year=valve;
            this.loadData();
        },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  width: 100vw;
  height: 100vh;
  background: #F3F4F6;
  display: flex;
  .flex(column);
  .listView {
        background-color: #F3F4F6 ;  //不设置 会导致某些手机 不显示界面？
        flex: 1;
        width: 100vw;
        min-height: 500px;
        margin-bottom: 20px;
        margin-top: 20px;
        border-radius: 8px 8px 8px 8px;
  }
}

.topBg{
    flex-direction: column;
    position: relative;
    width: 750px;
    height: 322px;
    background: #FFFFFF;
}

//轮播图
.swiper_bg{
    margin-top: 28px;
    margin-left: 28px;
    margin-right: 28px;
    width: 694px;
    height: 266px;
    background: linear-gradient(270deg, #FFBE00 0%, #FFA100 100%);
    box-shadow: 0px 8px 24px 0px #FFEAC8;
    border-radius: 12px;
    flex-direction: column;
}
.swiper_top{
    width: 694px;
    display: flex;
    height: 136px;
    flex-direction: column;
    position: relative;
}
.swiper_top_item1{
    width: 694px;
    display: flex;
    height: 40px;
    margin-top: 28px;
    flex-direction: row;
}
.swiper_top_item2{
    width: 694px;
    height: 40px;
    display: flex;
    margin-top: 8px;
    flex-direction: row;
}
.swiper_top_span1{
    margin-left: 28px;
    width: 100px;
    display: flex;
    height: 40px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span2{
    width: 452px;
    height: 40px;
    display: flex;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
.swiper_top_span3{
    position: absolute;
    right: 28px;
    top:28px;
    height: 32px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 32px;
}
.swiper_footer{
    width: 694px;
    height: 130px;
    background: rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
}
.swiper_top_span4{
     width: 638px;
    margin-top: 20px;
    margin-left: 28px;
    height: 34px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 34px;
}
.swiper_top_span5{
     margin-top: 8px;
    margin-left: 28px;
    width: 638px;
    height: 40px;
    font-size: 28px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
}
// 箭头。
.prevIcon{
    position: absolute;
    left: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;

}
.nextIcon{
    position: absolute;
    right: 20px;
    top: 140px;
    width: 44px;
    height: 44px;
    display: block;
}
.noSpan{
    color: #F3F4F6;
}
//listView
.listItem{
    display: flex;
    background-color: red;
    flex-direction: column;
    width: 750px;
    border-bottom: 1px solid #EAEAEA;
}
.listItemTop{
    width: 750px;
    display: flex;
    height: 156px;
    background: #FCFCFC;
    flex-direction: column;
}
.listItemTop_line{
    margin-top: 26px;
    width: 750px;
    display: flex;
    flex-direction: row;
}
.listItemTop_dot{
    margin-left: 10px;
    margin-top: 8px;
    width: 24px;
    height: 24px;
    // background: #FD9838;

}
.listItemTop_span{
    margin-left: 28px;
    height: 44px;
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    line-height: 44px;
}

.listItemTop_line1{
    width: 750px;
    display: flex;
    margin-top: 16px;
    flex-direction: row;
}

.listItemTop_span1{
    margin-left: 28px;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
}
.listItemTop_span2{
    margin-left: 6px;
    margin-right: 6px;
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #FD9838;
    line-height: 40px;
}
.listItemTop_span3{
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
}

.list_bodyItem{
    border-top: 1px solid #EAEAEA;;
    width: 750px;
    height: 100px;
    display: flex;
    background: #FFFFFF;
    flex-direction: column;
    // padding-bottom: 28px;
}

.list_bodyItem_line{
    flex-direction: row;
    justify-content: space-between;
    width: 750px;
    display: flex;
}
.list_bodyItem_div{
    flex-direction: row;
    margin-top: 28px;
    // margin-right: 28px;
}
.list_bodyItem_span1{
    margin-left: 28px;
    margin-top: 30px;
    height: 40px;
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
}
.list_bodyItem_span2{
    margin-right: 14px;
    margin-top: 30px;
    height: 40px;
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
}

.list_bodyItem_span3{
    margin-right: 28px;
    margin-top: 16px;
    height: 40px;
    font-size: 26px;
    color: #999999;
    line-height: 40px;
}

////pick
.picker {
    width:100%;
}
.picker-items {
    height: 100px!important;
}
.picker_wrap {
    height: 100px;
    display: flex;
    justify-content: space-between;
    padding: 0 28px;
    box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
    flex: 1;
    font-size: 32px;
    text-align: left;
    line-height: 100px;
}
.picker_btn2 {
    text-align: right;
    color: @color17;
}


</style>